import { useMemo } from 'react';
import { ReportInternalType, ReportStatus, useGroupedReportsQuery } from '@/__generated__/graphql';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state/atoms';

export const useFetchReportGroups = (
  type: ReportInternalType,
  status: ReportStatus,
  searchTerm: string | undefined
) => {
  const selectedReportFilters = useAtomValue(state.selectedReportFilters);
  const structureId = useGetStructureId();

  const selectedAssemblyTemplateFilters = useMemo(() => {
    return Object.entries(selectedReportFilters).map(([key, value]) => ({ id: key, value: value }));
  }, [selectedReportFilters]);

  const { data, loading, error } = useGroupedReportsQuery({
    variables: {
      input: {
        structureId,
        internalType: type,
        status,
        name: searchTerm,
        ...(type === ReportInternalType.Component && {
          selectedAssemblyTemplateFilters,
        }),
      },
    },
    fetchPolicy: 'no-cache',
    skip: type !== ReportInternalType.Component,
  });

  const reportGroups = useMemo(() => {
    return (
      data?.groupedReports.map((group) => ({
        groupId: group?.groupId ?? '',
        groupName: group?.groupName ?? '',
        count: group?.count ?? 0,
      })) ?? []
    );
  }, [data?.groupedReports]);

  return {
    reportGroups,
    loading,
    error,
  };
};
